// Internationalization translations for AI Marketing Engine
// Supports: FR, EN, ES, DE

const translations = {
  fr: {
    // Common
    loading: "Chargement...",
    save: "Sauvegarder",
    saving: "Sauvegarde...",
    cancel: "Annuler",
    delete: "Supprimer",
    validate: "Valider",
    back: "Retour",
    today: "Aujourd'hui",
    week: "Semaine",
    month: "Mois",
    settings: "Paramètres",
    analytics: "Analytics",
    
    // Auth
    welcome: "Bienvenue",
    login: "Connexion",
    signup: "Inscription",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    loginButton: "Se connecter",
    signupButton: "S'inscrire",
    authSubtitle: "Connectez-vous ou créez votre compte pour commencer",
    
    // Dashboard
    myProjects: "Mes Projets",
    manageEngines: "Gérez vos moteurs marketing IA",
    newProject: "Nouveau Projet",
    noProjects: "Aucun projet pour le moment",
    noProjectsDesc: "Créez votre premier projet pour commencer à automatiser votre marketing avec l'IA",
    createFirstProject: "Créer mon premier projet",
    limitReached: "Limite atteinte",
    limitReachedDesc: "Passez à un plan supérieur pour créer plus de projets.",
    calendar: "Calendrier",
    active: "Actif",
    paused: "Pause",
    
    // Calendar
    generateCalendar: "Générer Calendrier 30j",
    singleContent: "Contenu unique",
    weekOf: "Semaine du",
    legend: "Légende:",
    validated: "Validé",
    draft: "Brouillon",
    disabled: "Désactivé",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer ce contenu ?",
    contentDeleted: "Contenu supprimé",
    
    // Content Editor
    editContent: "Édition du contenu",
    content: "Contenu",
    text: "Texte",
    characters: "caractères",
    hashtags: "Hashtags",
    hashtagsPlaceholder: "#marketing, #ai, #automation",
    callToAction: "Call-to-Action",
    ctaPlaceholder: "Ex: Découvrez plus sur notre site",
    publicationDate: "Date de publication",
    media: "Médias",
    changePhoto: "Changer de photo",
    searching: "Recherche...",
    enhance: "Améliorer",
    imageUrl: "URL de l'image",
    videoUrl: "URL de la vidéo",
    videoValidation: "Les vidéos nécessitent une validation humaine avant publication",
    imageTip: "Le texte marketing est dans votre post, pas dans l'image. Les images sans texte génèrent plus d'engagement.",
    realPhotos: "Photos réelles optimisées pour les réseaux sociaux",
    
    // AI Assistant
    aiAssistant: "Assistant IA",
    aiAssistantDesc: "Demandez des améliorations à votre contenu",
    startConversation: "Commencez une conversation",
    examples: "Exemples:",
    exampleEngaging: "Rends ce texte plus engageant",
    exampleLinkedIn: "Adapte pour LinkedIn",
    exampleShorten: "Raccourcis à 100 caractères",
    askQuestion: "Posez votre question...",
    
    // Generation feedback
    generating: "Génération en cours...",
    generatingTime: "Cela peut prendre 15-30 secondes",
    generatingCalendar: "Génération du calendrier...",
    generatingCalendarTime: "Analyse et création de contenu (~1-2 minutes)",
    contentGenerated: "Contenu généré avec succès !",
    calendarGenerated: "Calendrier généré !",
    generationError: "Erreur lors de la génération",
    
    // Project
    createProject: "Créer un nouveau projet",
    createProjectDesc: "Configurez votre moteur marketing IA. Chaque projet est complètement isolé et possède sa propre automatisation.",
    projectName: "Nom du projet",
    projectNamePlaceholder: "Ex: Blog Entreprise, E-commerce Mode...",
    projectNameDesc: "Un nom descriptif pour identifier votre projet",
    siteUrl: "URL du site",
    siteUrlDesc: "L'IA analysera ce site pour générer du contenu adapté",
    createProjectButton: "Créer le projet",
    whatHappens: "Ce qui se passe ensuite :",
    step1: "L'IA va analyser votre site",
    step2: "Un calendrier éditorial sera généré",
    step3: "Vous pourrez valider chaque contenu avant publication",
    step4: "L'automatisation reste OFF par défaut",
    
    // Edit Project
    editProject: "Modifier le Projet",
    projectSettings: "Paramètres du projet",
    editProjectDesc: "Modifiez les informations de votre projet. La langue éditoriale détermine la langue de génération de contenu.",
    editorialLanguage: "Langue éditoriale",
    languageNote: "Note importante :",
    languageAffects: "La langue affecte tous les contenus futurs",
    existingContent: "Les contenus existants ne seront pas modifiés",
    aiAdapts: "L'IA adaptera automatiquement le ton à la langue choisie",
    saveChanges: "Enregistrer les modifications",
    projectUpdated: "Projet mis à jour avec succès !",
    
    // Toasts
    accountCreated: "Compte créé avec succès !",
    loginSuccess: "Connexion réussie !",
    projectCreated: "Projet créé avec succès !",
    savedSuccess: "Modifications enregistrées !",
    contentValidated: "Contenu validé !",
    photoFound: "Photo réelle trouvée",
    noPhotoFound: "Aucune photo trouvée, génération IA...",
    imageGenerated: "Image IA générée avec succès !",
    imageEnhanced: "Image améliorée ! (recadrage + contraste + netteté)",
    errorLoading: "Erreur lors du chargement",
    errorSaving: "Erreur lors de la sauvegarde",
    errorGeneration: "Erreur lors de la génération",
    errorValidation: "Erreur lors de la validation",
    errorDelete: "Erreur lors de la suppression",
    
    // CTA default
    ctaDefault: "Pour en savoir plus :",
    
    // Status actions
    disable: "Désactiver",
    contentDisabled: "Contenu désactivé",
    contentDraft: "Contenu remis en brouillon",
    
    // Multi-platform
    generateMultiPlatform: "Générer multi-plateforme",
    generatingMulti: "Génération multi-plateforme...",
    generatingMultiTime: "Création des déclinaisons (~1-2 minutes)",
    multiPlatformSuccess: "Contenus générés pour toutes les plateformes !",
    theme: "Thème",
    themePlaceholder: "Ex: Lancement produit, promotion été...",
    
    // Delete all
    deleteAllContents: "Supprimer les articles à venir",
    deleteAllConfirm: "Êtes-vous sûr de vouloir supprimer tous les articles FUTURS de ce projet ? Les articles passés seront conservés.",
    allContentsDeleted: "Articles à venir supprimés (historique conservé)",
    
    // Themes extraction
    extractedThemes: "Thèmes marketing extraits",
    destinations: "Destinations",
    monuments: "Monuments & Lieux",
    experiences: "Expériences",
    editorialAngles: "Angles éditoriaux",
    seasonality: "Saisonnalité",
    keywords: "Mots-clés",
    brandTone: "Ton de marque",
    targetAudience: "Audience cible",
    validateThemes: "Valider les thèmes",
    themesValidated: "Thèmes validés !",
    recrawlSite: "Ré-analyser le site",
    crawlInProgress: "Analyse en cours...",
    lastCrawl: "Dernière analyse",
    themesNotValidated: "Non validés - Les contenus n'utilisent pas encore ces thèmes",
    
    // Predictor
    performancePredictor: "Performance Predictor™",
    predictedScore: "Score prédit",
    lowPotential: "Faible potentiel",
    mediumPotential: "Potentiel correct",
    highPotential: "Fort potentiel",
    suggestions: "Suggestions d'amélioration",
    applySuggestion: "Appliquer",
    scoreImproved: "Score amélioré !",
    upgradeForPredictor: "Passez à Premium pour les suggestions",
    premiumFeature: "Fonctionnalité Premium",
    
    // Publish now
    publishNow: "Poster maintenant",
    publishNowConfirm: "Publier ce contenu immédiatement ?",
    publishing: "Publication en cours...",
    publishedSuccess: "Contenu publié avec succès !",
    publishError: "Erreur lors de la publication",
    noApiConfigured: "Aucune API configurée pour cette plateforme",
    
    // X Integration
    integrations: "Intégrations",
    integrationsDesc: "Connectez vos comptes de réseaux sociaux",
    xIntegrationDesc: "Publiez automatiquement sur X",
    connected: "Connecté",
    notConnected: "Non connecté",
    notConfigured: "Non configuré",
    connectedAs: "Connecté en tant que",
    howToGetCredentials: "Comment obtenir vos credentials X",
    setupSteps: "Étapes de configuration",
    step1CreateAccount: "Créez un compte développeur X (gratuit)",
    step2CreateApp: "Créez un nouveau Project puis une App",
    step3ConfigAuth: "Configurez 'User authentication settings'",
    step4GetKeys: "Récupérez le Client ID et Client Secret",
    callbackNote: "Assurez-vous que le Callback URL correspond exactement",
    enterCredentials: "Entrez vos credentials X",
    clientIdRequired: "Client ID est requis",
    credentialsSaved: "Credentials sauvegardées !",
    savedCredentials: "Credentials sauvegardées",
    updateCredentials: "Modifier",
    saveCredentials: "Sauvegarder les credentials",
    copyCallbackNote: "Copiez cette URL dans les paramètres de votre app X",
    connectX: "Connecter mon compte X",
    connecting: "Connexion...",
    confirmDisconnectX: "Êtes-vous sûr de vouloir déconnecter votre compte X ?",
    xDisconnected: "Compte X déconnecté",
    confirmDeleteCredentials: "Êtes-vous sûr de vouloir supprimer vos credentials X ?",
    credentialsDeleted: "Credentials supprimées",
    testPost: "Tester la publication",
    tweetText: "Texte du tweet",
    tweetTextRequired: "Le texte du tweet est requis",
    tweetPosted: "Tweet publié avec succès !",
    publishTest: "Publier le test",
    disconnect: "Déconnecter",
    xConnectedSuccess: "Compte X connecté avec succès !",
    xConnectionError: "Erreur de connexion X",
    comingSoon: "Bientôt disponible",
    copied: "Copié !",
    posting: "Publication...",
    published: "Publié",
    publishedAt: "Publié le",
    
    // Scheduler Status
    schedulerStatus: "Scheduler de publication",
    pending: "en attente",
    scheduled: "programmés",
    published24h: "publiés (24h)",
    errors: "erreurs",
    rateLimitedUntil: "Rate limit X - Reprise dans",
    pendingPublications: "En attente de publication",
    upcomingPublications: "Prochaines publications",
    recentErrors: "Erreurs récentes",
    recentlyPublished: "Récemment publiés",
    retryIn: "Réessai dans",
    noScheduledContent: "Aucun contenu programmé",
    now: "Maintenant",
  },
  
  en: {
    // Common
    loading: "Loading...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    validate: "Validate",
    back: "Back",
    today: "Today",
    week: "Week",
    month: "Month",
    settings: "Settings",
    analytics: "Analytics",
    
    // Auth
    welcome: "Welcome",
    login: "Login",
    signup: "Sign up",
    email: "Email",
    password: "Password",
    name: "Name",
    loginButton: "Log in",
    signupButton: "Sign up",
    authSubtitle: "Log in or create your account to get started",
    
    // Dashboard
    myProjects: "My Projects",
    manageEngines: "Manage your AI marketing engines",
    newProject: "New Project",
    noProjects: "No projects yet",
    noProjectsDesc: "Create your first project to start automating your marketing with AI",
    createFirstProject: "Create my first project",
    limitReached: "Limit reached",
    limitReachedDesc: "Upgrade to a higher plan to create more projects.",
    calendar: "Calendar",
    active: "Active",
    paused: "Paused",
    
    // Calendar
    generateCalendar: "Generate 30-day Calendar",
    singleContent: "Single content",
    weekOf: "Week of",
    legend: "Legend:",
    validated: "Validated",
    draft: "Draft",
    disabled: "Disabled",
    confirmDelete: "Are you sure you want to delete this content?",
    contentDeleted: "Content deleted",
    
    // Content Editor
    editContent: "Edit content",
    content: "Content",
    text: "Text",
    characters: "characters",
    hashtags: "Hashtags",
    hashtagsPlaceholder: "#marketing, #ai, #automation",
    callToAction: "Call-to-Action",
    ctaPlaceholder: "Ex: Learn more on our website",
    publicationDate: "Publication date",
    media: "Media",
    changePhoto: "Change photo",
    searching: "Searching...",
    enhance: "Enhance",
    imageUrl: "Image URL",
    videoUrl: "Video URL",
    videoValidation: "Videos require human validation before publishing",
    imageTip: "Marketing text goes in your post, not the image. Images without text generate more engagement.",
    realPhotos: "Real photos optimized for social media",
    
    // AI Assistant
    aiAssistant: "AI Assistant",
    aiAssistantDesc: "Ask for improvements to your content",
    startConversation: "Start a conversation",
    examples: "Examples:",
    exampleEngaging: "Make this text more engaging",
    exampleLinkedIn: "Adapt for LinkedIn",
    exampleShorten: "Shorten to 100 characters",
    askQuestion: "Ask your question...",
    
    // Generation feedback
    generating: "Generating...",
    generatingTime: "This may take 15-30 seconds",
    generatingCalendar: "Generating calendar...",
    generatingCalendarTime: "Analyzing and creating content (~1-2 minutes)",
    contentGenerated: "Content generated successfully!",
    calendarGenerated: "Calendar generated!",
    generationError: "Generation error",
    
    // Project
    createProject: "Create a new project",
    createProjectDesc: "Configure your AI marketing engine. Each project is completely isolated with its own automation.",
    projectName: "Project name",
    projectNamePlaceholder: "Ex: Company Blog, Fashion E-commerce...",
    projectNameDesc: "A descriptive name to identify your project",
    siteUrl: "Website URL",
    siteUrlDesc: "AI will analyze this site to generate adapted content",
    createProjectButton: "Create project",
    whatHappens: "What happens next:",
    step1: "AI will analyze your website",
    step2: "An editorial calendar will be generated",
    step3: "You can validate each content before publishing",
    step4: "Automation stays OFF by default",
    
    // Edit Project
    editProject: "Edit Project",
    projectSettings: "Project settings",
    editProjectDesc: "Modify your project information. The editorial language determines the content generation language.",
    editorialLanguage: "Editorial language",
    languageNote: "Important note:",
    languageAffects: "Language affects all future content",
    existingContent: "Existing content will not be modified",
    aiAdapts: "AI will automatically adapt tone to the chosen language",
    saveChanges: "Save changes",
    projectUpdated: "Project updated successfully!",
    
    // Toasts
    accountCreated: "Account created successfully!",
    loginSuccess: "Login successful!",
    projectCreated: "Project created successfully!",
    savedSuccess: "Changes saved!",
    contentValidated: "Content validated!",
    photoFound: "Real photo found",
    noPhotoFound: "No photo found, generating with AI...",
    imageGenerated: "AI image generated successfully!",
    imageEnhanced: "Image enhanced! (crop + contrast + sharpness)",
    errorLoading: "Loading error",
    errorSaving: "Saving error",
    errorGeneration: "Generation error",
    errorValidation: "Validation error",
    errorDelete: "Deletion error",
    
    // CTA default
    ctaDefault: "Learn more:",
    
    // Status actions
    disable: "Disable",
    contentDisabled: "Content disabled",
    contentDraft: "Content set to draft",
    
    // Multi-platform
    generateMultiPlatform: "Generate multi-platform",
    generatingMulti: "Multi-platform generation...",
    generatingMultiTime: "Creating variations (~1-2 minutes)",
    multiPlatformSuccess: "Content generated for all platforms!",
    theme: "Theme",
    themePlaceholder: "Ex: Product launch, summer sale...",
    
    // Delete all
    deleteAllContents: "Delete upcoming articles",
    deleteAllConfirm: "Are you sure you want to delete all FUTURE articles from this project? Past articles will be preserved.",
    allContentsDeleted: "Upcoming articles deleted (history preserved)",
    
    // Themes extraction
    extractedThemes: "Extracted marketing themes",
    destinations: "Destinations",
    monuments: "Monuments & Places",
    experiences: "Experiences",
    editorialAngles: "Editorial angles",
    seasonality: "Seasonality",
    keywords: "Keywords",
    brandTone: "Brand tone",
    targetAudience: "Target audience",
    validateThemes: "Validate themes",
    themesValidated: "Themes validated!",
    recrawlSite: "Re-analyze site",
    crawlInProgress: "Analysis in progress...",
    lastCrawl: "Last analysis",
    themesNotValidated: "Not validated - Content does not yet use these themes",
    
    // Predictor
    performancePredictor: "Performance Predictor™",
    predictedScore: "Predicted score",
    lowPotential: "Low potential",
    mediumPotential: "Good potential",
    highPotential: "High potential",
    suggestions: "Improvement suggestions",
    applySuggestion: "Apply",
    scoreImproved: "Score improved!",
    upgradeForPredictor: "Upgrade to Premium for suggestions",
    premiumFeature: "Premium feature",
    
    // Publish now
    publishNow: "Publish now",
    publishNowConfirm: "Publish this content immediately?",
    publishing: "Publishing...",
    publishedSuccess: "Content published successfully!",
    publishError: "Publication error",
    noApiConfigured: "No API configured for this platform",
    
    // X Integration
    integrations: "Integrations",
    integrationsDesc: "Connect your social media accounts",
    xIntegrationDesc: "Automatically publish to X",
    connected: "Connected",
    notConnected: "Not connected",
    notConfigured: "Not configured",
    connectedAs: "Connected as",
    howToGetCredentials: "How to get your X credentials",
    setupSteps: "Setup steps",
    step1CreateAccount: "Create a free X developer account",
    step2CreateApp: "Create a new Project then an App",
    step3ConfigAuth: "Configure 'User authentication settings'",
    step4GetKeys: "Get your Client ID and Client Secret",
    callbackNote: "Make sure the Callback URL matches exactly",
    enterCredentials: "Enter your X credentials",
    clientIdRequired: "Client ID is required",
    credentialsSaved: "Credentials saved!",
    savedCredentials: "Saved credentials",
    updateCredentials: "Update",
    saveCredentials: "Save credentials",
    copyCallbackNote: "Copy this URL to your X app settings",
    connectX: "Connect my X account",
    connecting: "Connecting...",
    confirmDisconnectX: "Are you sure you want to disconnect your X account?",
    xDisconnected: "X account disconnected",
    confirmDeleteCredentials: "Are you sure you want to delete your X credentials?",
    credentialsDeleted: "Credentials deleted",
    testPost: "Test post",
    tweetText: "Tweet text",
    tweetTextRequired: "Tweet text is required",
    tweetPosted: "Tweet posted successfully!",
    publishTest: "Post test",
    disconnect: "Disconnect",
    xConnectedSuccess: "X account connected successfully!",
    xConnectionError: "X connection error",
    comingSoon: "Coming soon",
    copied: "Copied!",
    posting: "Posting...",
    published: "Published",
    publishedAt: "Published on",
    
    // Scheduler Status
    schedulerStatus: "Publishing Scheduler",
    pending: "pending",
    scheduled: "scheduled",
    published24h: "published (24h)",
    errors: "errors",
    rateLimitedUntil: "X Rate limit - Retry in",
    pendingPublications: "Pending publications",
    upcomingPublications: "Upcoming publications",
    recentErrors: "Recent errors",
    recentlyPublished: "Recently published",
    retryIn: "Retry in",
    noScheduledContent: "No scheduled content",
    now: "Now",
  },
  
  es: {
    // Common
    loading: "Cargando...",
    save: "Guardar",
    saving: "Guardando...",
    cancel: "Cancelar",
    delete: "Eliminar",
    validate: "Validar",
    back: "Volver",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    settings: "Configuración",
    analytics: "Analíticas",
    
    // Auth
    welcome: "Bienvenido",
    login: "Iniciar sesión",
    signup: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre",
    loginButton: "Entrar",
    signupButton: "Registrarse",
    authSubtitle: "Inicia sesión o crea tu cuenta para empezar",
    
    // Dashboard
    myProjects: "Mis Proyectos",
    manageEngines: "Gestiona tus motores de marketing IA",
    newProject: "Nuevo Proyecto",
    noProjects: "Ningún proyecto por el momento",
    noProjectsDesc: "Crea tu primer proyecto para empezar a automatizar tu marketing con IA",
    createFirstProject: "Crear mi primer proyecto",
    limitReached: "Límite alcanzado",
    limitReachedDesc: "Actualiza a un plan superior para crear más proyectos.",
    calendar: "Calendario",
    active: "Activo",
    paused: "Pausado",
    
    // Calendar
    generateCalendar: "Generar Calendario 30d",
    singleContent: "Contenido único",
    weekOf: "Semana del",
    legend: "Leyenda:",
    validated: "Validado",
    draft: "Borrador",
    disabled: "Desactivado",
    confirmDelete: "¿Estás seguro de que quieres eliminar este contenido?",
    contentDeleted: "Contenido eliminado",
    
    // Content Editor
    editContent: "Edición de contenido",
    content: "Contenido",
    text: "Texto",
    characters: "caracteres",
    hashtags: "Hashtags",
    hashtagsPlaceholder: "#marketing, #ia, #automatizacion",
    callToAction: "Llamada a la acción",
    ctaPlaceholder: "Ej: Descubre más en nuestro sitio",
    publicationDate: "Fecha de publicación",
    media: "Medios",
    changePhoto: "Cambiar foto",
    searching: "Buscando...",
    enhance: "Mejorar",
    imageUrl: "URL de la imagen",
    videoUrl: "URL del vídeo",
    videoValidation: "Los vídeos requieren validación humana antes de publicar",
    imageTip: "El texto de marketing va en tu post, no en la imagen. Las imágenes sin texto generan más engagement.",
    realPhotos: "Fotos reales optimizadas para redes sociales",
    
    // AI Assistant
    aiAssistant: "Asistente IA",
    aiAssistantDesc: "Pide mejoras para tu contenido",
    startConversation: "Inicia una conversación",
    examples: "Ejemplos:",
    exampleEngaging: "Haz este texto más atractivo",
    exampleLinkedIn: "Adapta para LinkedIn",
    exampleShorten: "Acorta a 100 caracteres",
    askQuestion: "Haz tu pregunta...",
    
    // Generation feedback
    generating: "Generando...",
    generatingTime: "Esto puede tomar 15-30 segundos",
    generatingCalendar: "Generando calendario...",
    generatingCalendarTime: "Analizando y creando contenido (~1-2 minutos)",
    contentGenerated: "¡Contenido generado con éxito!",
    calendarGenerated: "¡Calendario generado!",
    generationError: "Error de generación",
    
    // Project
    createProject: "Crear un nuevo proyecto",
    createProjectDesc: "Configura tu motor de marketing IA. Cada proyecto está completamente aislado con su propia automatización.",
    projectName: "Nombre del proyecto",
    projectNamePlaceholder: "Ej: Blog Empresa, E-commerce Moda...",
    projectNameDesc: "Un nombre descriptivo para identificar tu proyecto",
    siteUrl: "URL del sitio",
    siteUrlDesc: "La IA analizará este sitio para generar contenido adaptado",
    createProjectButton: "Crear proyecto",
    whatHappens: "Lo que pasa después:",
    step1: "La IA analizará tu sitio web",
    step2: "Se generará un calendario editorial",
    step3: "Podrás validar cada contenido antes de publicar",
    step4: "La automatización permanece APAGADA por defecto",
    
    // Edit Project
    editProject: "Editar Proyecto",
    projectSettings: "Configuración del proyecto",
    editProjectDesc: "Modifica la información de tu proyecto. El idioma editorial determina el idioma de generación de contenido.",
    editorialLanguage: "Idioma editorial",
    languageNote: "Nota importante:",
    languageAffects: "El idioma afecta todo el contenido futuro",
    existingContent: "El contenido existente no será modificado",
    aiAdapts: "La IA adaptará automáticamente el tono al idioma elegido",
    saveChanges: "Guardar cambios",
    projectUpdated: "¡Proyecto actualizado con éxito!",
    
    // Toasts
    accountCreated: "¡Cuenta creada con éxito!",
    loginSuccess: "¡Inicio de sesión exitoso!",
    projectCreated: "¡Proyecto creado con éxito!",
    savedSuccess: "¡Cambios guardados!",
    contentValidated: "¡Contenido validado!",
    photoFound: "Foto real encontrada",
    noPhotoFound: "No se encontró foto, generando con IA...",
    imageGenerated: "¡Imagen IA generada con éxito!",
    imageEnhanced: "¡Imagen mejorada! (recorte + contraste + nitidez)",
    errorLoading: "Error de carga",
    errorSaving: "Error al guardar",
    errorGeneration: "Error de generación",
    errorValidation: "Error de validación",
    errorDelete: "Error al eliminar",
    
    // CTA default
    ctaDefault: "Más información:",
    
    // Status actions
    disable: "Desactivar",
    contentDisabled: "Contenido desactivado",
    contentDraft: "Contenido vuelto a borrador",
    
    // Multi-platform
    generateMultiPlatform: "Generar multi-plataforma",
    generatingMulti: "Generación multi-plataforma...",
    generatingMultiTime: "Creando variaciones (~1-2 minutos)",
    multiPlatformSuccess: "¡Contenidos generados para todas las plataformas!",
    theme: "Tema",
    themePlaceholder: "Ej: Lanzamiento producto, promoción verano...",
  },
  
  de: {
    // Common
    loading: "Laden...",
    save: "Speichern",
    saving: "Speichert...",
    cancel: "Abbrechen",
    delete: "Löschen",
    validate: "Validieren",
    back: "Zurück",
    today: "Heute",
    week: "Woche",
    month: "Monat",
    settings: "Einstellungen",
    analytics: "Analytik",
    
    // Auth
    welcome: "Willkommen",
    login: "Anmelden",
    signup: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    loginButton: "Einloggen",
    signupButton: "Registrieren",
    authSubtitle: "Melden Sie sich an oder erstellen Sie Ihr Konto",
    
    // Dashboard
    myProjects: "Meine Projekte",
    manageEngines: "Verwalten Sie Ihre KI-Marketing-Engines",
    newProject: "Neues Projekt",
    noProjects: "Noch keine Projekte",
    noProjectsDesc: "Erstellen Sie Ihr erstes Projekt, um Ihr Marketing mit KI zu automatisieren",
    createFirstProject: "Mein erstes Projekt erstellen",
    limitReached: "Limit erreicht",
    limitReachedDesc: "Upgraden Sie auf einen höheren Plan, um mehr Projekte zu erstellen.",
    calendar: "Kalender",
    active: "Aktiv",
    paused: "Pausiert",
    
    // Calendar
    generateCalendar: "30-Tage-Kalender generieren",
    singleContent: "Einzelner Inhalt",
    weekOf: "Woche vom",
    legend: "Legende:",
    validated: "Validiert",
    draft: "Entwurf",
    disabled: "Deaktiviert",
    confirmDelete: "Sind Sie sicher, dass Sie diesen Inhalt löschen möchten?",
    contentDeleted: "Inhalt gelöscht",
    
    // Content Editor
    editContent: "Inhalt bearbeiten",
    content: "Inhalt",
    text: "Text",
    characters: "Zeichen",
    hashtags: "Hashtags",
    hashtagsPlaceholder: "#marketing, #ki, #automatisierung",
    callToAction: "Call-to-Action",
    ctaPlaceholder: "Bsp: Erfahren Sie mehr auf unserer Website",
    publicationDate: "Veröffentlichungsdatum",
    media: "Medien",
    changePhoto: "Foto ändern",
    searching: "Suche...",
    enhance: "Verbessern",
    imageUrl: "Bild-URL",
    videoUrl: "Video-URL",
    videoValidation: "Videos erfordern menschliche Validierung vor der Veröffentlichung",
    imageTip: "Marketing-Text gehört in Ihren Post, nicht ins Bild. Bilder ohne Text erzeugen mehr Engagement.",
    realPhotos: "Echte Fotos, optimiert für Social Media",
    
    // AI Assistant
    aiAssistant: "KI-Assistent",
    aiAssistantDesc: "Bitten Sie um Verbesserungen für Ihren Inhalt",
    startConversation: "Gespräch starten",
    examples: "Beispiele:",
    exampleEngaging: "Mach diesen Text ansprechender",
    exampleLinkedIn: "Für LinkedIn anpassen",
    exampleShorten: "Auf 100 Zeichen kürzen",
    askQuestion: "Stellen Sie Ihre Frage...",
    
    // Generation feedback
    generating: "Generierung läuft...",
    generatingTime: "Dies kann 15-30 Sekunden dauern",
    generatingCalendar: "Kalender wird generiert...",
    generatingCalendarTime: "Analysieren und Erstellen von Inhalten (~1-2 Minuten)",
    contentGenerated: "Inhalt erfolgreich generiert!",
    calendarGenerated: "Kalender generiert!",
    generationError: "Generierungsfehler",
    
    // Project
    createProject: "Neues Projekt erstellen",
    createProjectDesc: "Konfigurieren Sie Ihre KI-Marketing-Engine. Jedes Projekt ist komplett isoliert mit eigener Automatisierung.",
    projectName: "Projektname",
    projectNamePlaceholder: "Bsp: Firmenblog, Mode E-Commerce...",
    projectNameDesc: "Ein beschreibender Name zur Identifizierung Ihres Projekts",
    siteUrl: "Website-URL",
    siteUrlDesc: "KI wird diese Seite analysieren, um angepassten Inhalt zu generieren",
    createProjectButton: "Projekt erstellen",
    whatHappens: "Was als nächstes passiert:",
    step1: "KI wird Ihre Website analysieren",
    step2: "Ein Redaktionskalender wird erstellt",
    step3: "Sie können jeden Inhalt vor der Veröffentlichung validieren",
    step4: "Automatisierung bleibt standardmäßig AUS",
    
    // Edit Project
    editProject: "Projekt bearbeiten",
    projectSettings: "Projekteinstellungen",
    editProjectDesc: "Ändern Sie Ihre Projektinformationen. Die Redaktionssprache bestimmt die Inhaltsgenerierungssprache.",
    editorialLanguage: "Redaktionssprache",
    languageNote: "Wichtiger Hinweis:",
    languageAffects: "Die Sprache beeinflusst alle zukünftigen Inhalte",
    existingContent: "Bestehende Inhalte werden nicht geändert",
    aiAdapts: "KI passt den Ton automatisch an die gewählte Sprache an",
    saveChanges: "Änderungen speichern",
    projectUpdated: "Projekt erfolgreich aktualisiert!",
    
    // Toasts
    accountCreated: "Konto erfolgreich erstellt!",
    loginSuccess: "Anmeldung erfolgreich!",
    projectCreated: "Projekt erfolgreich erstellt!",
    savedSuccess: "Änderungen gespeichert!",
    contentValidated: "Inhalt validiert!",
    photoFound: "Echtes Foto gefunden",
    noPhotoFound: "Kein Foto gefunden, KI-Generierung...",
    imageGenerated: "KI-Bild erfolgreich generiert!",
    imageEnhanced: "Bild verbessert! (Zuschnitt + Kontrast + Schärfe)",
    errorLoading: "Ladefehler",
    errorSaving: "Speicherfehler",
    errorGeneration: "Generierungsfehler",
    errorValidation: "Validierungsfehler",
    errorDelete: "Löschfehler",
    
    // CTA default
    ctaDefault: "Mehr erfahren:",
    
    // Status actions
    disable: "Deaktivieren",
    contentDisabled: "Inhalt deaktiviert",
    contentDraft: "Inhalt auf Entwurf gesetzt",
    
    // Multi-platform
    generateMultiPlatform: "Multi-Plattform generieren",
    generatingMulti: "Multi-Plattform-Generierung...",
    generatingMultiTime: "Variationen erstellen (~1-2 Minuten)",
    multiPlatformSuccess: "Inhalte für alle Plattformen generiert!",
    theme: "Thema",
    themePlaceholder: "Bsp: Produkteinführung, Sommeraktion...",
  }
};

export default translations;
